import type { ReactNode } from 'react';

export const symbol_grouped_bar_chart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-160q-12.75 0-21.37-8.63Q160-177.25 160-190v-420q0-12.75 8.63-21.38Q177.25-640 190-640h80q12.75 0 21.38 8.62Q300-622.75 300-610v420q0 12.75-8.62 21.37Q282.75-160 270-160h-80Zm210 0q-12.75 0-21.37-8.63Q370-177.25 370-190v-220q0-12.75 8.63-21.38Q387.25-440 400-440h80q12.75 0 21.38 8.62Q510-422.75 510-410v220q0 12.75-8.62 21.37Q492.75-160 480-160h-80Zm290 0q-12.75 0-21.37-8.63Q660-177.25 660-190v-580q0-12.75 8.63-21.38Q677.25-800 690-800h80q12.75 0 21.38 8.62Q800-782.75 800-770v580q0 12.75-8.62 21.37Q782.75-160 770-160h-80Z"
		/>
	</svg>
);
